<div class="page-wrapper">
  <div class="deco-blob-1"></div>
  <div class="deco-blob-2"></div>
  <div class="grid-overlay"></div>

  <div class="page-container">

    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
      </div>
      <div class="nav-meta">
        <span class="nav-tag"><i class="fas fa-hospital-alt"></i> Hospital OS</span>
      </div>
    </header>

    <main class="main-content">
      <div class="split-layout">

        <!-- Left: Branding Panel -->
        <div class="brand-panel animate-left">
          <div class="brand-icon-wrap">
            <i class="fas fa-shield-virus"></i>
          </div>
          <h1 class="brand-heading">Secure Access<br /><span class="gradient-text">Reset Required</span></h1>
          <p class="brand-desc">
            Your password has expired as part of our clinical security policy.
            Please set a new password to regain access to your medical dashboard.
          </p>

          <div class="security-badges">
            <div class="sec-badge">
              <i class="fas fa-lock"></i>
              <span>256-bit Encrypted</span>
            </div>
            <div class="sec-badge">
              <i class="fas fa-user-shield"></i>
              <span>HIPAA Compliant</span>
            </div>
            <div class="sec-badge">
              <i class="fas fa-check-double"></i>
              <span>2FA Ready</span>
            </div>
          </div>
        </div>

        <!-- Right: Form Card -->
        <div class="form-side animate-up">
          <div class="reset-card">
            <div class="card-top-bar"></div>

            <div class="card-inner">
              <div class="card-eyebrow">
                <i class="fas fa-key"></i>
                Password Reset
              </div>

              <h2 class="card-title">Set New Password</h2>
              <p class="card-subtitle">
                Choose a strong password to protect your clinical account.
              </p>

              <form>
                <div class="input-group">
                  <label for="new-password">
                    New Password <span class="req">*</span>
                  </label>
                  <div class="input-wrap">
                    <i class="fas fa-lock input-icon"></i>
                    <input
                      type="password"
                      id="new-password"
                      name="newPassword"
                      [(ngModel)]="newPassword"
                      #newPass="ngModel"
                      placeholder="Min. 6 characters"
                      required
                      minlength="6"
                    />
                  </div>
                  <div class="field-error" *ngIf="newPass.invalid && newPass.touched">
                    <span *ngIf="newPass.errors?.['required']">
                      <i class="fas fa-exclamation-circle"></i> New password is required.
                    </span>
                    <span *ngIf="newPass.errors?.['minlength']">
                      <i class="fas fa-exclamation-circle"></i> Password must be at least 6 characters.
                    </span>
                  </div>
                </div>

                <div class="input-group">
                  <label for="confirm-password">
                    Confirm Password <span class="req">*</span>
                  </label>
                  <div class="input-wrap">
                    <i class="fas fa-check-circle input-icon"></i>
                    <input
                      type="password"
                      id="confirm-password"
                      name="confirmPassword"
                      [(ngModel)]="confirmPassword"
                      #confirmPass="ngModel"
                      placeholder="Re-enter new password"
                      required
                    />
                  </div>
                  <div class="field-error" *ngIf="confirmPass.touched && confirmPassword !== newPassword">
                    <i class="fas fa-exclamation-circle"></i> Passwords do not match.
                  </div>
                  <div class="field-error" *ngIf="confirmPass.touched && confirmPass.errors?.['required']">
                    <i class="fas fa-exclamation-circle"></i> Confirm password is required.
                  </div>
                </div>

                <!-- Password strength hint -->
                <div class="password-hint" *ngIf="newPassword">
                  <div class="hint-bar">
                    <div class="hint-fill"
                         [style.width]="newPassword.length >= 10 ? '100%' : newPassword.length >= 6 ? '60%' : '25%'"
                         [class.weak]="newPassword.length < 6"
                         [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                         [class.strong]="newPassword.length >= 10">
                    </div>
                  </div>
                  <span class="hint-label"
                        [class.weak]="newPassword.length < 6"
                        [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                        [class.strong]="newPassword.length >= 10">
                    {{ newPassword.length < 6 ? 'Weak' : newPassword.length < 10 ? 'Fair' : 'Strong' }}
                  </span>
                </div>

                <button
                  type="button"
                  class="btn-submit"
                  [disabled]="!newPassword || !confirmPassword || newPassword !== confirmPassword"
                  (click)="updatePassword()"
                >
                  <i class="fas fa-shield-alt"></i>
                  <span>Update Password</span>
                </button>
              </form>

              <div class="card-footer-links">
                <a routerLink="/login" class="back-link">
                  <i class="fas fa-arrow-left"></i> Back to Login
                </a>
                <a (click)="redirectToSignUp()" class="signup-link" style="cursor:pointer;">
                  New here? <strong>Create account</strong>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </main>

    <footer class="bottom-bar">
      <span>&copy; 2026 Nishwik Hospital OS. Secure &amp; Compliant.</span>
      <!-- <div class="social-links">
        <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
        <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
      </div> -->
    </footer>

  </div>
</div>